(function(){
  var root=document.getElementById('aps'); if(!root) return;
  var I=window.APS_I18N||{};
  var FR={label:'FR',html:'fr',app:'fr',punct:'.',words:['carré','story','bannière','portrait','sur-mesure']};
  var LANGS=['fr','en'].filter(function(l){return l==='fr'||I[l];});
  /* Une adresse par langue : kaleidoads.com (français) et kaleidoads.com/en (anglais). */
  var URLS={fr:'/',en:'/en'};
  function P(l){return l==='fr'?FR:I[l];}
  var curLang='fr', ri=0;
  function setLang(lang){
    if(LANGS.indexOf(lang)<0) lang='fr';
    curLang=lang; ri=0; var D=P(lang);
    root.querySelectorAll('[data-i]').forEach(function(el){
      if(el.dataset.fr===undefined) el.dataset.fr=el.innerHTML;
      var k=el.getAttribute('data-i'); el.innerHTML=(lang!=='fr'&&D.t[k]!==undefined)?D.t[k]:el.dataset.fr;
    });
    var r=root.querySelector('.rot'); if(r) r.textContent=D.words[0]+D.punct;
    var mo=root.querySelector('.morph'); if(mo) mo.className='morph m0';
    root.querySelectorAll('[data-it]').forEach(function(el){
      if(el.dataset.frt===undefined) el.dataset.frt=el.getAttribute('data-type');
      var k=el.getAttribute('data-it'); el.setAttribute('data-type',lang==='fr'?el.dataset.frt:D.typed[k]);
      if(el.textContent) el.textContent=el.getAttribute('data-type');
    });
    root.querySelectorAll('[data-ia]').forEach(function(el){
      if(el.dataset.fra===undefined) el.dataset.fra=el.getAttribute('aria-label');
      el.setAttribute('aria-label',lang==='fr'?el.dataset.fra:D.aria);
    });
    root.querySelectorAll('a[href*="app.kaleidoads.com/"]').forEach(function(a){
      a.href=a.href.replace(/\/(fr|en)\/app/,'/'+D.app+'/app');
    });
    root.querySelectorAll('.lang-menu button').forEach(function(b){b.setAttribute('aria-checked',b.getAttribute('data-lang')===lang?'true':'false');});
    var cur=root.querySelector('.lang-cur'); if(cur) cur.textContent=D.label;
    document.documentElement.lang=D.html;
  }
  /* Changer de langue = changer d'adresse (la page se recharge sur l'URL de la langue). */
  function goLang(lang){
    if(LANGS.indexOf(lang)<0||lang===curLang) return;
    var u=new URL(window.location.href); u.searchParams.delete('lang');
    window.location.href=URLS[lang]+u.search+u.hash;
  }
  /* La langue vient de l'adresse (fournie par Shopify dans data-lang). */
  var lang=root.getAttribute('data-lang')==='en'?'en':'fr';
  /* Anciens liens en ?lang= : renvoi vers l'adresse propre de la langue. */
  try{
    var u0=new URL(window.location.href), p=u0.searchParams.get('lang');
    if(p!==null){
      u0.searchParams.delete('lang');
      if(p==='en'&&lang!=='en'){window.location.replace(URLS.en+u0.search+u0.hash);return;}
      history.replaceState(null,'',u0.pathname+u0.search+u0.hash);
    }
    localStorage.removeItem('aps-lang');
  }catch(e){}
  setLang(lang);
  var box=root.querySelector('.lang'), btn=root.querySelector('.lang-btn');
  function openMenu(o){if(!box)return;box.classList.toggle('open',o);btn.setAttribute('aria-expanded',o?'true':'false');}
  if(btn){btn.addEventListener('click',function(e){e.stopPropagation();openMenu(!box.classList.contains('open'));});}
  root.querySelectorAll('.lang-menu button').forEach(function(b){b.addEventListener('click',function(){openMenu(false);goLang(b.getAttribute('data-lang'));});});
  document.addEventListener('click',function(e){if(box&&!box.contains(e.target))openMenu(false);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')openMenu(false);});
  if(!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)){
    setInterval(function(){var el=root.querySelector('.rot');if(!el||document.hidden)return;el.classList.add('out');
      setTimeout(function(){var D=P(curLang);ri=(ri+1)%D.words.length;el.textContent=D.words[ri]+D.punct;var mo=root.querySelector('.morph');if(mo)mo.className='morph m'+ri;el.classList.remove('out');el.classList.add('pre');void el.offsetWidth;el.classList.remove('pre');},260);},2200);
  }
  var nav=document.getElementById('aps-nav'), mcta=document.getElementById('aps-mcta'), hero=root.querySelector('.hero .ctas'), final=root.querySelector('.final');
  function onScroll(){var y=window.scrollY||0; if(nav) nav.classList.toggle('scrolled',y>8);
    if(hero&&final&&mcta){var hb=hero.getBoundingClientRect().bottom, ft=final.getBoundingClientRect().top; mcta.classList.toggle('show',hb<0&&ft>window.innerHeight);}}
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  var els=root.querySelectorAll('.rv');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el);});
  } else { els.forEach(function(el){el.classList.add('in');}); }
  root.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var t=root.querySelector(a.getAttribute('href'));if(t){e.preventDefault();var w=t.querySelector('.wrap')||t,off=(nav?nav.offsetHeight:56)+24;window.scrollTo({top:Math.max(0,w.getBoundingClientRect().top+window.scrollY-off),behavior:'smooth'});}});});
  (function(){
    var wrap=nav&&nav.querySelector('.wrap'), right=nav&&nav.querySelector('.nav-right'), menu=nav&&nav.querySelector('.menu');
    if(!wrap||!right||!menu) return;
    var L={fr:['Menu','Langue','Fermer'],en:['Menu','Language','Close']};
    function tr(i){var l=document.documentElement.lang||'fr';return (L[l]||L[l.slice(0,2)]||L.fr)[i];}
    var b=document.createElement('button'); b.type='button'; b.className='burger'; b.setAttribute('aria-expanded','false'); b.setAttribute('aria-controls','aps-msheet'); b.innerHTML='<i></i>';
    right.appendChild(b);
    var sh=document.createElement('div'); sh.className='msheet'; sh.id='aps-msheet'; sh.setAttribute('role','dialog'); sh.setAttribute('aria-modal','true');
    root.appendChild(sh);
    var open=false;
    function build(){
      var h='<nav class="ml">';
      menu.querySelectorAll('a').forEach(function(a,i){h+='<a href="'+a.getAttribute('href')+'" data-k="'+i+'"'+(a.classList.contains('on')?' class="on"':'')+' style="animation-delay:'+(40+i*45)+'ms"><span>'+a.innerHTML+'</span><span class="ar" aria-hidden="true">›</span></a>';});
      h+='</nav>';
      var lb=root.querySelectorAll('.lang-menu button');
      if(lb.length){h+='<p class="mlab">'+tr(1)+'</p><div class="mlang">';lb.forEach(function(x,i){h+='<button type="button" data-l="'+i+'" aria-pressed="'+x.getAttribute('aria-checked')+'">'+x.textContent+'</button>';});h+='</div>';}
      var cta=right.querySelector('.btn'), big=root.querySelector('.hero [data-i="cta"]');
      if(cta) h+='<a class="btn mcta-s" href="'+cta.href+'">'+(big?big.textContent:cta.textContent)+'</a>';
      sh.innerHTML=h; b.setAttribute('aria-label',open?tr(2):tr(0));
      sh.querySelectorAll('.ml a').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();var o=menu.querySelectorAll('a')[+a.getAttribute('data-k')];toggle(false);if(o)setTimeout(function(){o.click();},10);});});
      sh.querySelectorAll('.mlang button').forEach(function(x){x.addEventListener('click',function(){var o=lb[+x.getAttribute('data-l')];if(o)o.click();});});
    }
    function toggle(o){
      open=o; if(o){build();sh.style.top=nav.getBoundingClientRect().bottom+'px';}
      sh.classList.toggle('open',o); nav.classList.toggle('mopen',o); b.setAttribute('aria-expanded',o?'true':'false'); b.setAttribute('aria-label',o?tr(2):tr(0));
      document.documentElement.style.overflow=o?'hidden':'';
    }
    b.setAttribute('aria-label',tr(0));
    b.addEventListener('click',function(e){e.stopPropagation();toggle(!open);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&open){toggle(false);b.focus();}});
    window.addEventListener('resize',function(){if(open&&window.innerWidth>820)toggle(false);});
  })();
})();
